import React from 'react';
import styles from './index.module.scss';

const scrollToAuthorCard = (authorFilterTag) => {
  if (!authorFilterTag) return;

  const normalizedTargetTag = String(authorFilterTag).trim().toLowerCase();
  const authorCardElement = Array.from(document.querySelectorAll('[data-filter-tag]')).find(
    (el) =>
      String(el.getAttribute('data-filter-tag') || '')
        .trim()
        .toLowerCase() === normalizedTargetTag,
  );

  if (!authorCardElement) return;

  const header = document.querySelector('header');
  const headerOffset = (header?.offsetHeight || 60) + 16;
  const targetY = authorCardElement.getBoundingClientRect().top + window.scrollY - headerOffset;

  window.scrollTo({
    top: Math.max(targetY, 0),
    behavior: 'smooth',
  });
};

const getAuthorLabel = (authorsCount, labelKind) => {
  if (labelKind === 'project') {
    return authorsCount === 1 ? 'Автор проекта' : 'Авторы проекта';
  }

  return authorsCount === 1 ? 'Автор публикации' : 'Авторы публикации';
};

const AuthorAvatars = ({
  authors = [],
  variant = 'dark',
  className = '',
  enableScroll = true,
  placement = 'top',
  labelKind = 'publication',
}) => {
  if (!Array.isArray(authors) || authors.length === 0) return null;

  const label = getAuthorLabel(authors.length, labelKind);

  const sectionClassName = [
    styles.authorsByline,
    variant === 'light' ? styles.light : '',
    placement === 'footer' ? styles.footer : '',
    placement === 'pageHeader' ? styles.pageHeader : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={sectionClassName}>
      <div className={styles.authorsNames}>
        <span className={styles.authorLabel}>{label}:</span>
        {authors.map((author, index) => (
          <React.Fragment key={author.filterTag || author.name || index}>
            {index > 0 && <span className={styles.separator}>, </span>}
            <button
              type='button'
              className={styles.authorName}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                if (enableScroll) {
                  scrollToAuthorCard(author.filterTag);
                }
              }}>
              {author.name}
            </button>
          </React.Fragment>
        ))}
      </div>
      {placement !== 'footer' && <div className={styles.authorsRule} aria-hidden='true' />}
    </div>
  );
};

export default AuthorAvatars;
